import React from 'react'
import { AdminCategories } from '../../../../Components/Views'
import useActivityAdmin from '../../../../Hooks/CategoriesAdmin'

const Render = () => {
    const props = useActivityAdmin()
    return (
        <AdminCategories  {...props} />
    )
}

export default Render